import React from 'react';
import { MapContainer, TileLayer, Polyline } from 'react-leaflet';
import polyline from 'polyline-encoded';
import 'leaflet/dist/leaflet.css';

/**
 * RouteMap component - Displays a route on a map using Leaflet
 * Extracted to separate component for better performance and easier mocking
 */
const RouteMap = ({ summaryPolyline, height = '200px', showPlaceholder = false }) => {
  if (!summaryPolyline) {
    if (showPlaceholder) {
      return (
        <div style={{ height, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f3f4f6', borderRadius: '8px' }}>
          <p style={{ color: '#6b7280', fontSize: '14px' }}>No route data available</p>
        </div>
      );
    }
    return null;
  }

  try {
    const decoded = polyline.decode(summaryPolyline);
    const routeCoordinates = decoded.map(coord => [coord[0], coord[1]]);

    if (routeCoordinates.length === 0) {
      return null;
    }

    const latSum = routeCoordinates.reduce((sum, coord) => sum + coord[0], 0);
    const lngSum = routeCoordinates.reduce((sum, coord) => sum + coord[1], 0);
    const center = [latSum / routeCoordinates.length, lngSum / routeCoordinates.length];

    return (
      <div style={{ height, width: '100%', borderRadius: '8px', overflow: 'hidden' }}>
        <MapContainer
          key={summaryPolyline}
          center={center}
          zoom={14}
          style={{ height: '100%', width: '100%' }}
          scrollWheelZoom={false}
          dragging={false}
          zoomControl={false}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; OpenStreetMap'
          />
          <Polyline
            positions={routeCoordinates}
            color="#14b8a6"
            weight={4}
            opacity={0.8}
          />
        </MapContainer>
      </div>
    );
  } catch (e) {
    console.error('Error rendering route map:', e);
    return null;
  }
};

export default RouteMap;
